const userSelector = (state: any) => state.user;
const roleSelector = (state: any) => state.role;
const orgSelector = (state: any) => state.org;

export { userSelector, roleSelector, orgSelector };
